import styles from './skills.module.css';
import OneSkill from './OneSkill'

const Skills=()=>{ 
    return <div id="skills" className={styles.main}>
        <h1 className="text_theme">My <span className="text-blue">Skills</span></h1>
        <div className={styles.skill_flex}>
        <OneSkill skill="vscode-icons:file-type-html" sName="HTML"/><OneSkill/>
        <OneSkill skill="vscode-icons:file-type-css" sName="CSS"/><OneSkill/>
        <OneSkill className={styles.icon_rotate} skill="logos:react" sName="React.js"/><OneSkill/>
        <OneSkill skill="logos:javascript" sName="JavaScript"/><OneSkill/>
        <OneSkill skill="logos:redux" sName="Redux"/><OneSkill/>
        <OneSkill className={styles.icon_invert} skill="logos:express" sName="Express.js"/><OneSkill/>
        <OneSkill skill="logos:nodejs-icon" sName="Node.js"/><OneSkill/>
        <OneSkill skill="logos:mongodb" sName="MongoDB"/><OneSkill/>
        <OneSkill skill="logos:sass" sName="Sass"/><OneSkill/>
        <OneSkill skill="logos:tailwindcss" sName="Tailwind CSS"/><OneSkill/>
        <OneSkill skill="logos:netlify" sName="Netlify"/><OneSkill/>
        <OneSkill skill="logos:heroku" sName="Heroku"/><OneSkill/>
        <OneSkill className={styles.icon_invert} skill="logos:github-icon" sName="Github"/><OneSkill/>
        <OneSkill skill="logos:python" sName="Python"/><OneSkill/>
        <OneSkill skill="logos:java" sName="Java"/><OneSkill/>
        <OneSkill skill="logos:mysql" sName="MySql"/><OneSkill/>

        
         </div>
        
    </div>
}

export default Skills;
 
